import React from 'react';
import PropTypes from 'prop-types';
import indexOf from 'lodash/indexOf';
import Helmet from 'react-helmet';
import BrandUtils from '../../utils/BrandUtils';
import { ResultSection } from '../common/sections/ResultSection';
import { PageHeader } from '../common/PageHeader';
import ProductUtils from '../../utils/ProductUtils';
import ContentUtils from '../../utils/ContentUtils';

function SorryPage({ content, data }) {
  /**
   * Get the content key SorryPageExplanation2
   * If productCode is not allowed to have 'find out more' text then don't add it. Otherwise do.
   *
   * @return {String} Return SorryPageExplanation2 with declinedFindOutMore if allowed.
   */
  const getSorryPageExplanation2 = () => {
    const explanation = ContentUtils.getProductContent(
      'sorryPageExplanation2',
      content,
      data.productCode
    );
    const string =
      explanation &&
      explanation.replace(
        '{findOutMore}',
        indexOf(
          [/* cannotFindOutMore Product Codes */ 'IM800'],
          data.productCode
        ) >= 0
          ? ''
          : ` ${content.sorryFindOutMore}`
      );

    return string.length ? <p>{string}</p> : null;
  };

  return (
    <div className="internet-banking result-page-wrapper declined-page-wrapper container-fluid">
      <Helmet title={content.sorryPageHeader} />
      <PageHeader
        visible={BrandUtils.isAbleToDisplay('result-pages-header')}
        title={
          content.landingPageTitle + ProductUtils.getName(data.productCode)
        }
        content={content}
      />
      <div className="result-page white-board declined-page" role="main">
        <div className="row text-center">
          <div className="col-xs-12">
            <ResultSection
              imgSrc={BrandUtils.getResultImage(
                'declined-page-with-image',
                'sorry-illustration.png'
              )}
              imgAlt="Declined Result"
              title={content.sorryPageTitle}
            >
              <p>
                {ContentUtils.getProductContent(
                  'sorryPageExplanation1',
                  content,
                  data.productCode
                )}
              </p>
              {getSorryPageExplanation2()}
              {content.sorryPageExplanation3 && (
                <p>{content.sorryPageExplanation3}</p>
              )}
              {content.sorryPageExplanation3DYB && (
                <p>{content.sorryPageExplanation3DYB}</p>
              )}
              {content.sorryPageExplanation4DYB && (
                <p>{content.sorryPageExplanation4DYB}</p>
              )}
              <a
                href={content.sorryPageFormLink}
                title={content.sorryPageFormLinkTitle}
                target="_blank"
                rel="noreferrer"
              >
                {content.sorryPageFormLinkText}
              </a>
              <a
                href={content.sorryPageFormLink2}
                title={content.sorryPageFormLinkTitle2}
                target="_blank"
                rel="noreferrer"
              >
                {content.sorryPageFormLinkText2}
              </a>
            </ResultSection>
          </div>
        </div>
      </div>
    </div>
  );
}

SorryPage.propTypes = {
  data: PropTypes.object,
  validations: PropTypes.object,
  content: PropTypes.object,
};

export { SorryPage };
